<template>
  <div class="tengend" :style="{ height: heagintH + 'px' }">
    <el-button
      type="primary"
      icon="el-icon-edit"
      style="margin: 20px"
      @click="addHnadn"
      v-if="roletypeValue == 0"
      >新增继电器</el-button
    >
    <el-table
      :data="tableData"
      style="width: 100%"
      :height="heagintH - 120"
      :header-cell-style="{
        background: '#eef1f6',
        color: '#606266',
        textAlign: 'center',
      }"
      :row-class-name="tableRowClassName"
      border
    >
      <el-table-column prop="roadid" label="继电器路数"></el-table-column>
      <el-table-column prop="channelid" label="关联通道数"></el-table-column>
      <el-table-column
        prop="electricname"
        label="关联用电设备"
      ></el-table-column>
      <!-- <el-table-column prop="address" label="添加时间"></el-table-column> -->
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            round
            icon="el-icon-edit"
            type="primary"
            @click="editFrom(row)"
            >编辑</el-button
          >
          <!--  -->
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            round
            @click="deleData(row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <page-helper
      :page-data="pageData"
      :total="total"
      :get-table-list="getTable"
    ></page-helper>
    <!-- 继电器弹框 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="50%"
      :modal="false"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <div class="frodData">
          <div class="flends">
            <el-form-item
              label="选择路数:"
              prop="roadid"
              style="padding-bottom: 10px"
              label-width="110px"
            >
              <div class="fleEnd">
                <el-select
                  v-model="ruleForm.roadid"
                  placeholder="选择路数"
                  style="width: 100%"
                  @change="funTchelci"
                >
                  <el-option
                    :label="item.roadiview"
                    :value="item.roadid"
                    v-for="(item, index) in getDataOption"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item
              label="选择用电设备:"
              prop="electricuuid"
              style="padding-bottom: 10px"
              label-width="110px"
            >
              <el-select
                v-model="ruleForm.electricuuid"
                placeholder="选择用电设备"
                style="width: 100%"
                @change="changConfing"
              >
                <el-option
                  :label="item.name"
                  :value="item.uuid"
                  v-for="item in confingOption"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item
            v-if="infoData.Istrip != 1"
            label="选择关联通道:"
            prop="channelid"
            style="padding-bottom: 10px"
            label-width="110px"
          >
            <el-select
              v-model="ruleForm.channelid"
              placeholder="选择关联通道"
              style="width: 100%"
              @change="handChange"
            >
              <el-option
                v-for="item in optioneChendId"
                :label="'通道' + item.channelid + ':' + item.lable"
                :value="item.channelid"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="infoData.Istrip == 1"
            label="卷帘组号："
            prop="channelid"
            style="padding-bottom: 10px;"
            label-width="110px"
          >
            <el-input style="width: 100%" v-model="ruleForm.roadid"></el-input>
          </el-form-item>

          <el-form-item
            v-if="infoData.Istrip == 1"
            label="卷帘类型:"
            prop="channelid"
            style="padding-bottom: 10px"
            label-width="110px"
          >
            <el-select
              v-model="ruleForm.channelid"
              placeholder="选择卷帘类型"
              style="width: 100%"
              @change="handChange"
            >
              <el-option
                v-for="item in optioneType"
                :label="item.lable"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="选择路数2:"
            prop="roadid"
            style="padding-bottom: 10px"
            label-width="110px"
            v-if="infoData.Istrip == 1"
          >
            <div class="fleEnd">
              <el-select
                v-model="ruleForm.roadid"
                placeholder="选择路数"
                style="width: 100%"
                @change="funTchelci"
              >
                <el-option
                  :label="item.roadiview"
                  :value="item.roadid"
                  v-for="(item, index) in getDataOption"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            v-if="infoData.Istrip == 1"
            label="卷帘类型2:"
            prop="channelid"
            style="padding-bottom: 10px"
            label-width="110px"
          >
            <el-select
              v-model="ruleForm.channelid"
              placeholder="选择卷帘类型"
              style="width: 100%"
              @change="handChange"
            >
              <el-option
                v-for="item in optioneType"
                :label="item.lable"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="infoData.Istrip == 1"
            label="消耗时"
            prop="channelid"
            style="padding-bottom: 10px;"
            label-width="110px"
          >
            <el-input v-model="ruleForm.onvalue" style="width: 80%"></el-input>
            {{ unitFint }}
          </el-form-item>
        </div>
        <!-- 继电器控制阈值 -->
        <h3 class="titleInfo">继电器控制阈值</h3>
        <!-- 针对多个参数 -->
        <!-- <div class="jdq_warp" v-if="infoData.Istrip == 1">
          <el-form-item
            :label="infoData.onname + ':'"
            prop="onvalue"
            style="padding-bottom: 10px"
          >
            <el-input v-model="ruleForm.onvalue" style="width: 80%"></el-input>
            {{ unitFint }}
          </el-form-item>
          <el-form-item
            :label="infoData.offname + ':'"
            prop="offvalue"
            style="padding-bottom: 10px"
          >
            <el-input v-model="ruleForm.offvalue" style="width: 80%"></el-input>
            {{ unitFint }}
          </el-form-item>
          <el-form-item
            :label="infoData.onname + '1' + ':'"
            prop="onvalue1"
            style="padding-bottom: 10px"
          >
            <el-input v-model="ruleForm.onvalue2" style="width: 80%"></el-input>
            {{ unitFint }}
          </el-form-item>
          <el-form-item
            :label="infoData.offname + '1' + ':'"
            prop="offvalue1"
            style="padding-bottom: 10px"
          >
            <el-input
              v-model="ruleForm.offvalue2"
              style="width: 80%"
            ></el-input>
            {{ unitFint }}
          </el-form-item>
        </div> -->
        <!-- 一个参数 -->
        <div class="jdq_warp" v-if="infoData.Istrip == 0">
          <el-form-item
            :label="infoData.onname + ':'"
            prop="onvalue"
            style="padding-bottom: 10px"
          >
            <el-input v-model="ruleForm.onvalue" style="width: 80%"></el-input>
            {{ unitFint }}
          </el-form-item>
          <el-form-item
            :label="infoData.offname + ':'"
            prop="offvalue"
            style="padding-bottom: 10px"
          >
            <el-input v-model="ruleForm.offvalue" style="width: 80%"></el-input>
            {{ unitFint }}
          </el-form-item>
        </div>
        <!-- <el-form-item label="继电器标识:" prop="name" style="padding-bottom:10px">
          <el-radio-group v-model="ruleForm.radio">
            <el-radio :label="3">手动</el-radio>
            <el-radio :label="6">自动</el-radio>
          </el-radio-group>
        </el-form-item>-->
      </el-form>
      <span slot="footer" class="dialog-footer forDataInfoCentent">
        <el-button @click="hiendClick">取 消</el-button>
        <el-button type="primary" @click="handConfing">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 监听数据变化 -->
    {{ handValue }}
  </div>
</template>

<script>
import {
  listTableScont,
  CamanetSet,
  wangGuan_sun,
  EditHnadList,
} from "../../../network/lineRequest";
import { listwgtd, dealerDelete } from "../../../network/index";
import PageHelper from "@/components/common/PageHelper";
export default {
  components: {
    PageHelper,
  },
  props: {
    gatewayuuid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      optioneType: [
        {
          lable: "上升",
          id: 1,
        },
        {
          lable: "下降",
          id: 2,
        },
      ],
      getDataOption: [],
      roletypeValue: sessionStorage.getItem("roletypeValue"),
      title: "",
      rules: {
        roadid: [{ required: true, message: "选择路数", trigger: "change" }],
        channelid: [
          { required: true, message: "选择关联通道", trigger: "change" },
        ],
        electricuuid: [
          { required: true, message: "选择用电设备", trigger: "change" },
        ],
        onvalue: [{ required: true, message: "请输入开启值", trigger: "blur" }],
        offvalue: [
          { required: true, message: "请输入断开值", trigger: "blur" },
        ],
      },
      confingOption: [],
      optioneChendId: [], //选择管理土洞
      pageData: {
        pagenum: 1, //页码  pagenum  2
        pagesize: 30, //数据   pagesize几条数据
      },
      total: null,
      dialogVisible: false,
      tableData: [],
      ruleForm: {
        roadid: "",
        roadid2: "",
        channelid: "",
        channel_uuid: "", //所属通道UUID
        sensingunit_uuid: "", //所属传感单元UUID
        onvalue: "", //系和值
        offvalue: "", //断开至
        onvalue2: "", //系和值
        offvalue2: "", //断开至
        electricuuid: "", //关联设备id
        gateway_uuid: "",
      },
      unitFint: "℃",
      lang_file: sessionStorage.getItem("lang_file"),
      infoData: {}, //电子设备的信息
    };
  },
  created() {},
  mounted() {},
  computed: {
    handValue() {
      if (this.gatewayuuid) {
        this.getTable();
      }
    },
    heagintH() {
      return window.innerHeight - 150;
    },
  },
  methods: {
    // 获取数据
    funTchelci() {
      let uindex = this.ruleForm.roadid;
      this.ruleForm.roadid2 = uindex + 1;
    },
    deleData(row) {
      this.$confirm("此操作将永久删除该电用设备, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { code, data, msg } = await dealerDelete(
            row.uuid,
            "tb_gateway_control"
          );
          if (code) {
            this.getTable();
            this.$message({
              type: "success",
              message: msg,
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭按钮
    handleClose(done) {
      done();

      this.handListn();
    },
    async getUiindList() {
      const { code, data, msg } = await wangGuan_sun({
        gateway_uuid: this.gatewayuuid,
      });
      // console.log(data);
      if (code) {
        this.getDataOption = data;
      }
    },
    // 取消按钮
    hiendClick() {
      this.dialogVisible = false;
      this.handListn();
    },
    // 编辑
    editFrom(row) {
      // console.log(row);
      this.getUiindList();
      this.title = "修改继电器";
      this.chandindChend(); //获取数据
      this.ruleForm = { ...row };
      this.infoData = { ...row };
      this.dialogVisible = true;
    },
    // 确定按钮
    handConfing() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const { code, data, msg } = await EditHnadList(this.ruleForm);
          if (code) {
            this.$message.success(msg);
            this.handListn();
            this.getTable();
            this.dialogVisible = false;
            return;
          }
          this.$message.error(msg);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 清空数据列表
    handListn() {
      this.ruleForm = {};
      this.$refs.ruleForm.resetFields();
    },
    //获取table列表
    async getTable() {
      this.pageData.gateway_uuid = this.gatewayuuid;
      const { code, data, msg } = await listTableScont(this.pageData);
      // console.log(data, "----");
      if (code) {
        this.tableData = data.list;
        this.total = Number(data.pagelist[0].allrow);
      }
    },
    //添加继电器
    addHnadn() {
      this.ruleForm.gateway_uuid = this.gatewayuuid;
      this.title = "新增继电器";
      this.getUiindList();
      this.chandindChend();
      this.dialogVisible = true;
    },
    // 获取通道号
    async chandindChend() {
      // 获取通道号
      this.optioneChendId = [];
      const { code, data, msg } = await listwgtd(this.gatewayuuid, 1, 32);

      if (code) {
        this.confingList(); //获取电子设备
        data.list.forEach((item) => {
          item.lable =
            this.lang_file == "zh-cn" ? item.unittype : item.unittype_en;
          this.optioneChendId.push(item);
        });

        // console.log( this.optioneChendId);
      }
    },
    // 获取通道号单位
    handChange(e) {
      let indexFon = this.optioneChendId.findIndex(
        (item) => item.channelid == e
      );
      this.unitFint =
        this.lang_file == "zh-cn"
          ? this.optioneChendId[indexFon].unit
          : this.optioneChendId[indexFon].unit_en;
      this.ruleForm.channel_uuid = this.optioneChendId[indexFon].uuid; //所属通道UUID
      this.ruleForm.sensingunit_uuid = this.optioneChendId[
        indexFon
      ].sensingunit_uuid; //所属传感单元UUID
    },
    // 获取电子设备的信息
    changConfing(e) {
      let indexFon = this.confingOption.findIndex((item) => item.uuid == e);
      // console.log(this.confingOption[indexFon]);

      this.infoData = this.confingOption[indexFon];
      this.ruleForm.electricuuid = this.confingOption[indexFon].uuid; //关联设备uuid
    },
    // 选择用电设备
    async confingList() {
      const { code, data, msg } = await CamanetSet({});
      if (code) {
        this.confingOption = data;
      }
    },
    //   斑马线
    tableRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
  },
};
</script>

<style lang="scss">
.fleEnd {
  display: flex;
  // width: 50%;
}
.forDataInfoCentent {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}
.frodData {
  // width: 500px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.flends {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.titleInfo {
  text-align: center;
}
.el_elbles {
  text-align: center;
  padding: 30px 0;
}
.jdq_warp {
  background: #f8f8f8;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  input[type="text"] {
    border: none;
  }
}
</style>
